import axios, { AxiosError } from 'axios';
import { AppViews } from 'endpoints';
import humps from 'humps';
import Qs from 'qs';
import { sendError } from 'services/error-webhook';

const SendGridApi = axios.create({
  baseURL: process.env.REACT_APP_SENDGRID_URL,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_SENDGRID_API_KEY}`,
    'Content-Type': 'application/json',
  },
  transformResponse: [...(axios.defaults.transformResponse as []), (data) => humps.camelizeKeys(data)],
  paramsSerializer(params) {
    return Qs.stringify(humps.decamelizeKeys(params), {
      arrayFormat: 'brackets',
    });
  },
});

SendGridApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response != null && error.response.status === 401) {
      window.location.href = AppViews.AGENCY_LOGIN;
    }
    sendError(error, window.location.href, error.response?.request.responseURL);
    return Promise.reject(error);
  },
);

export default SendGridApi;
